<template>
    <div class="mainCarouselWrapper">
            <!-- <template #back-arrow>
                <div class="custom-arrow-main">
                    <img 
                        :src="require('../../../../assetsUniversal/icons/left-arrow.svg')"
                    >
                </div>
            </template>
            <template #next-arrow>
                <div class="custom-arrow-next-main">
                    <img 
                        :src="require('../../../../assetsUniversal/icons/left-arrow.svg')"
                    >
                </div>
            </template> -->
            <Galleria :value="slides" :numVisible="5" :circular="true" class="carousel1"
                :showItemNavigators="true">
                <template #item="slotProps">
                    <img :src="slotProps.item" alt="slotProp" class="galleriaImage" style="width: 100%; display: block;" />
                </template>
            </Galleria>
        <!-- <div class="imageCount">
            <p>{{ currentImage + 1 }} / {{ slides.length }}</p>
        </div> -->
    </div>
  <!-- <vue-image-lightbox-carousel
      class="lightBoxCarousel"
      ref="lightbox"
      :show="showLightbox"
      @close="closeGallery()"
      :images="images"
      :showCaption="false"
    >
  </vue-image-lightbox-carousel> -->
</template>

<script>
// import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
import Galleria from 'primevue/galleria';

export default {
  name: 'listingMainHeader',
  components: {
    Galleria
    //   VueImageLightboxCarousel,
  },

  props: {
    fetchDataListing: {
      required: true
    },
    shopData: {
      required: true
    },
    slides: {
      required: true
    },
  },
  data() {
    return {
      idListing: Number(this.$route.params.id),
      show: 1,

      images: [],
      smallImages: [],
      showLightbox: false,
      currentImage: 0,
    }
  },  
  methods: {
    round(num, decimalPlaces = 0) {
        num = Math.round(num + "e" + decimalPlaces);
        return Number(num + "e" + -decimalPlaces);
    },

    openGallery () {
        this.images = []
        for(const element of this.slides) {
            this.images.push({
                path: element
            })
        }
        this.showLightbox = true
        document.documentElement.style.overflow = 'hidden'
    },

    closeGallery() {
        this.showLightbox = false
        document.documentElement.style.overflow = 'auto'
    },

    decideSmallImages() {
        if(this.slides.length == 1) {
            this.smallImages.push(this.$fetchIp+'/static/images/shops/'+this.shopData.coverImg)
            this.smallImages.push(this.slides[0])
        }
        if(this.slides.length == 2) {
            this.smallImages.push(this.$fetchIp+'/static/images/shops/'+this.shopData.coverImg)
            this.smallImages.push(this.slides[1])
        }
        if(this.slides.length >= 3) {
            this.smallImages.push(this.slides[1])
            this.smallImages.push(this.slides[2])
        }
    }
  },
    created() {
        this.decideSmallImages()
    },
    mounted() {
        if(this.slides.length > 4) {
            this.show = 4
        } else {
            this.show = this.slides.length
        }
    }
}
</script>
<style>
.mainCarouselWrapper .p-galleria {
    width: 640px;
    height: 470px;
    border-radius: 20px;
}
@media(max-width: 1350px) {
    .mainCarouselWrapper .p-galleria {
        position: relative;
        width: 100%;
        min-width: 650px
    }
    .listingMainHeader {
        position: relative;
        width: 100%;
    }
}
@media(max-width: 1100px) {
    .mainCarouselWrapper .p-galleria {
        min-width: 500px
    }
}
@media(max-width: 900px) {
    .mainCarouselWrapper .p-galleria {
        min-width: 400px
    }
}
@media(max-width: 800px) {
    .mainCarouselWrapper .p-galleria {
        width: 100%;
        min-width: 100%;
    }
}

/* @media(max-width: 1570px) {
    .mainCarouselWrapper .p-galleria {
        width: 630px;
    }
    
} */
</style>
<style scoped>
.lightBoxCarousel {
    z-index: 100000;
}
.listingTitle {
    position: relative;
    text-align: left;
    width: 100%;
}
.title {
    margin: 0;
    font-size: 2rem;
    color: rgb(75, 75, 75);
    font-weight: 400;
}
.title:hover {
    color: rgb(25,25,25);
    cursor: pointer;
}
.listingTitle p {
    position: relative;
    width: 100%;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 8px;
    font-size: 1.3rem;
    font-weight: 700;
    font-family: 'Lato', sans-serif;
    color: rgb(62, 101, 110);
}
.listingTitle span {
    position: absolute;
    right: 5px;
    font-weight: 400;
}
.listingTitle span:hover {
    color: #64C3A2;
    cursor: pointer;
}
.galleriaImage {
    display: block;
    width: 100%;
    height: 410px;
    -o-object-fit: contain;
       object-fit: contain;
    background: white;
}
.profileMain {
    position: relative;
    margin: 0 auto;
    margin-bottom: 15px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}
/* .carousel1 {
    position: relative;
    width: 100%;
    height: 525px;
    margin: 0 auto;
    padding: 0;
    background: white;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 10px;
    -o-object-fit: contain;
       object-fit: contain;
} */
.mainImages {
    z-index: 10;
    cursor: pointer;
    width: 100%;
    height: 523px;
    -o-object-fit: contain;
       object-fit: contain;
    opacity: 1;
}
.imageCount {
    position: absolute;
    z-index: 100;
    bottom: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    padding: 1px 0px 1px 0px;
    width: 50px;
    text-align: center;
    border-radius: 5px;
}
.imageCount p {
    margin: 0;
    font-size: .9rem;
    font-family: 'DM sans', sans-serif;
}
.smallImg {
    margin-left: 25px;
}
.smallImg img {
    width: 321px;
    height: 253px;
    margin-bottom: 11px;
    border: 1px solid rgb(230, 230, 230);
    border-radius: 10px;
    background: white;
    cursor: pointer;
    -o-object-fit: contain;
       object-fit: contain;
}
.listingImages {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.mainCarouselWrapper {
    position: relative;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 0px;
    margin-left: 0px;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
}
.mainCarouselWrapper:hover .custom-arrow-main img {
    opacity: 1;
}
.mainCarouselWrapper:hover .custom-arrow-next-main img {
    opacity: 1;
}
.custom-arrow-main {
    position: absolute;
    top: -4px;
    bottom: 0;
    left: -38px;
    margin: auto;
    height: 45px;
    width: 45px;
    z-index: 500;
    cursor: pointer;
    background: rgb(250,250,250);
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,.3);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,.3);
    border-radius: 100%;
}
.custom-arrow-main img {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 3px;
    left: 0;
    margin: auto;
    height: 25px;
    opacity: 1;
}
.custom-arrow-next-main {
    position: absolute;
    top: -4px;
    bottom: 0;
    right: -38px;
    margin: auto;
    height: 45px;
    width: 45px;
    z-index: 500;
    cursor: pointer;
    background: rgb(250,250,250);
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,.3);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,.3);
    border-radius: 100%;
}
.custom-arrow-next-main img {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 3px;
    margin: auto;
    height: 25px;
    opacity: 1;
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}
</style>